(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
